export default "/profile/images/search.svg?8d74b08fd60f2318844dda8c9f5c37ea";